import React from 'react';
import ButtonsPreview from './ButtonsPreview';
import BodyText from './BodyText';
import MediaPreview from './MediaPreview';
import { formatText } from './TemplateUtils';

const RegularTemplateContent = ({
  headerType,
  headerText,
  effectiveMediaType,
  mediaPreview,
  bodyText,
  footerText,
  buttons,
  currentTime,
  sampleValues = {},
  mode = 'create'
}) => {
  return (
    <div className="bg-white dark:bg-[#1f2c34] rounded-lg rounded-tl-none shadow-sm max-w-[85%] overflow-hidden relative pb-6">
      {(headerType && headerType !== 'none') && (
        <div className="mb-2">
          {headerType === 'text' && headerText && (
            <p className="font-bold text-gray-900 dark:text-white px-3 pt-3 text-sm">
              {formatText(headerText, sampleValues)}
            </p>
          )}
        </div>
      )}

      {effectiveMediaType && effectiveMediaType !== 'none' && (
        <div className="mb-2 bg-gray-100 dark:bg-gray-700 rounded-sm overflow-hidden">
          <MediaPreview type={effectiveMediaType} preview={mediaPreview} mode={mode} />
        </div>
      )}

      <div className="px-3 pt-2 text-sm text-gray-800 dark:text-gray-100 whitespace-pre-wrap leading-relaxed">
        <BodyText text={bodyText} sampleValues={sampleValues} />
      </div>

      {footerText && (
        <div className="px-3 pt-1 text-[10px] text-gray-500 dark:text-gray-400">
          {footerText}
        </div>
      )}

      {buttons && buttons.length > 0 ? (
        <div className="px-3 pt-2 flex justify-end">
          <span className="text-[10px] text-gray-400 dark:text-gray-500">
            {currentTime}
          </span>
        </div>
      ) : (
        <div className="absolute bottom-1 right-2 flex items-center gap-1">
          <span className="text-[10px] text-gray-400 dark:text-gray-500">
            {currentTime}
          </span>
        </div>
      )}

      <ButtonsPreview buttons={buttons} />
    </div>
  );
};

export default RegularTemplateContent;
